import React from "react";
import { Navigate } from "react-router-dom";

const VendorListPageWrapper = () => {
  return <Navigate to="/vendor/list/all" />;
};

export default VendorListPageWrapper;
